/* gg-cart-capture.js — "Save your cart + get $10 off" email capture in the cart drawer and on /cart.
   Founder-approved 2026-10-21 (outputs/cro/2026-10-21-cart-to-checkout.md, Task A).

   Why: almost every cart was anonymous, so Klaviyo's Added to Cart flow (Xe9xL9) could not reach it. Klaviyo only
   records Added to Cart for visitors it already knows, and it does not back-fill an add made before identification
   (tested 2026-10-21). So on submit we:
     1. identify the browser in Klaviyo (klaviyo.identify) so every later cart / checkout event is tied to the email;
     2. subscribe the email to the Email List S5eay8 (double opt-in), the same list and $10 Welcome path as the popup;
     3. record the cart's newest line as an "Added to Cart" event tagged gg_source = cart_capture (see trackCapture).
   The offer is the live email-signup offer only ($10 off the first order, content-generation-rules offer table).
   No code is shown here: the Welcome flow emails each subscriber their own single-use code.

   Never shown to: visitors Klaviyo already identifies, signed-in customers, or anyone who submitted it or dismissed it
   with × this session. v2 (2026-10-21 evening, founder): it stays BELOW the cart lines (top of the drawer footer), but
   closing the drawer no longer counts as "seen": it keeps showing on every later drawer open and on /cart until a
   submit or ×. When the drawer is open and the box is out of view, a small "Get $10 off ↓" pill sits just above the
   pinned checkout bar; tapping it scrolls the drawer to the box (the drawer never scrolls by itself). Klaviyo popup UjjKC6 is untouched.
   Preview (2026-10-21 night, founder never saw it as a known subscriber): open any page with ?gg_cc_preview=1 and the box
   shows for that browser session whatever the identified / signed-in / done / dismissed state; ?gg_cc_preview=0 ends it.
   Real shoppers are unaffected (sessionStorage flag gg_cc_preview, set only by that URL parameter).
   Kill switch: set window.GG_CART_CAPTURE_OFF = true, or remove the script tag in layout/theme.liquid. */
(function () {
  'use strict';
  if (window.GG_CART_CAPTURE_OFF || window.__ggCartCapture) return;
  window.__ggCartCapture = true;

  var CFG = {
    company: 'W2BX7b',
    list: 'S5eay8',
    revision: '2024-10-15',
    source: 'Cart drawer capture'
  };
  var SS = 'gg_cc_state';   // sessionStorage: dismissed | done (a legacy 'shown' value is ignored since v2)
  var LS = 'gg_cc_done';    // localStorage: 1 once subscribed in this browser
  var PV = 'gg_cc_preview'; // sessionStorage: 1 = preview on (forced show), set by ?gg_cc_preview=1, cleared by =0
  try {
    var pq = new URLSearchParams(location.search).get(PV);
    if (pq === '1') sessionStorage.setItem(PV, '1');
    else if (pq === '0') sessionStorage.removeItem(PV);
  } catch (e) {}
  function preview() { try { return sessionStorage.getItem(PV) === '1'; } catch (e) { return false; } }

  function ssGet() { try { return sessionStorage.getItem(SS) || ''; } catch (e) { return ''; } }
  function ssSet(v) { try { sessionStorage.setItem(SS, v); } catch (e) {} }
  function lsDone() { try { return localStorage.getItem(LS) === '1'; } catch (e) { return false; } }
  function lsSet() { try { localStorage.setItem(LS, '1'); } catch (e) {} }

  var state = {
    eligible: null,     // null = unknown, true/false once checked
    phase: 'form',      // form | sending | done
    email: '',
    error: ''
  };

  function loggedIn() {
    try { return !!(window.__st && window.__st.cid) || !!(window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.page && ShopifyAnalytics.meta.page.customerId); } catch (e) { return false; }
  }
  function klaCookie() {
    try {
      var m = document.cookie.match(/(?:^|;\s*)__kla_id=([^;]+)/);
      return m ? JSON.parse(atob(decodeURIComponent(m[1]))) : {};
    } catch (e) { return {}; }
  }
  function cookieIdentified() {
    var k = klaCookie();
    /* An anonymous __kla_id holds only "cid". Klaviyo adds $exchange_id (or $email/$phone_number) only once it knows an
       email or phone for this browser (signup, identify, or a click from a Klaviyo email). */
    return !!(k.$exchange_id || k.$email || k.$phone_number);
  }

  function checkEligible() {
    if (state.eligible !== null) return Promise.resolve(state.eligible);
    if (preview()) { state.eligible = true; return Promise.resolve(true); }
    var st = ssGet();
    if (st === 'dismissed' || st === 'done' || lsDone() || loggedIn() || cookieIdentified()) {
      state.eligible = false; return Promise.resolve(false);
    }
    var k = window.klaviyo;
    if (k && typeof k.isIdentified === 'function') {
      return Promise.resolve(k.isIdentified()).then(function (id) { state.eligible = !id; return state.eligible; })
        .catch(function () { state.eligible = true; return true; });
    }
    state.eligible = true; return Promise.resolve(true);
  }

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function html() {
    if (state.phase === 'done') {
      return '<p class="gg-cc__title">You’re almost in</p>' +
        '<p class="gg-cc__sub">Confirm your email from the message we just sent. Your $10 code for your first order follows right after, and we’ll keep your cart saved.</p>';
    }
    var busy = state.phase === 'sending';
    return '<button type="button" class="gg-cc__close" aria-label="No thanks, close">×</button>' +
      '<p class="gg-cc__title" id="gg-cc-title">Save your cart + get $10 off</p>' +
      '<p class="gg-cc__sub">Sign up for our emails and take $10 off your first order. We’ll keep your cart saved too.</p>' +
      '<form class="gg-cc__form" novalidate aria-labelledby="gg-cc-title">' +
        '<label class="visually-hidden" for="gg-cc-email">Email address</label>' +
        '<input id="gg-cc-email" class="gg-cc__input" type="email" name="email" inputmode="email" autocomplete="email" autocapitalize="off" spellcheck="false" placeholder="Email address" value="' + esc(state.email) + '"' + (busy ? ' disabled' : '') + ' required>' +
        '<button type="submit" class="gg-cc__btn"' + (busy ? ' disabled' : '') + '>' + (busy ? 'Saving…' : 'Get $10 off') + '</button>' +
      '</form>' +
      (state.error ? '<p class="gg-cc__err" role="alert">' + esc(state.error) + '</p>' : '') +
      '<p class="gg-cc__legal">By signing up you agree to receive marketing emails from Gummy Gardens. Unsubscribe anytime. ' +
        '<a href="/policies/privacy-policy">Privacy policy</a>.</p>';
  }

  /* Where the box goes: top of the drawer footer (directly under the cart lines) and top of .cart__footer on /cart.
     Dawn re-renders #CartDrawer on every cart change, so paint() re-inserts it. */
  function slots() {
    var out = [];
    var foot = document.querySelector('#CartDrawer .drawer__footer');
    if (foot) out.push({ host: foot, after: null, drawer: true });
    document.querySelectorAll('.cart__footer').forEach(function (f) {
      if (!f.closest('#CartDrawer')) out.push({ host: f, after: null, drawer: false });
    });
    return out;
  }
  function cartHasItems(slot) {
    if (slot.drawer) {
      var d = slot.host.closest('cart-drawer');
      return !!d && !d.classList.contains('is-empty') && !!d.querySelector('.cart-item');
    }
    return !!document.querySelector('cart-items .cart-item, #main-cart-items .cart-item');
  }

  var painting = false;
  function paint() {
    if (painting) return;
    painting = true;
    try {
      slots().forEach(function (slot) {
        var host = slot.host;
        var box = host.querySelector(':scope > .gg-cc');
        var show = state.eligible === true && state.phase !== 'hidden' && cartHasItems(slot);
        if (!show) { if (box) box.remove(); return; }
        if (!box) {
          box = document.createElement('div');
          box.className = 'gg-cc' + (slot.drawer ? ' gg-cc--drawer' : '');
          box.setAttribute('role', 'region');
          box.setAttribute('aria-label', 'Save your cart');
        }
        if (box.getAttribute('data-phase') !== state.phase + '|' + state.error) {
          var active = document.activeElement && box.contains(document.activeElement) && document.activeElement.id === 'gg-cc-email';
          box.innerHTML = html();
          box.setAttribute('data-phase', state.phase + '|' + state.error);
          if (active) { var i = box.querySelector('#gg-cc-email'); if (i) { i.focus(); try { i.setSelectionRange(i.value.length, i.value.length); } catch (e) {} } }
        }
        if (slot.after) { if (slot.after.nextElementSibling !== box) host.insertBefore(box, slot.after.nextSibling); }
        else if (host.firstElementChild !== box) host.insertBefore(box, host.firstElementChild);
      });
    } finally { painting = false; }
    hint();
  }

  /* "Get $10 off ↓" pill, only while the drawer is open and the box is out of view. It lives on <cart-drawer> itself
     (outside #CartDrawer, which Dawn re-renders) with position:fixed, centred on the drawer panel and sitting just above
     the checkout bar when the bar is on screen, else near the bottom edge (with 3+ lines the bar starts below the fold). */
  function hint() {
    var d = document.querySelector('cart-drawer');
    if (!d) return;
    var inner = d.querySelector('.drawer__inner');
    var box = d.querySelector('.drawer__footer > .gg-cc');
    var pill = d.querySelector(':scope > .gg-cc-hint');
    var want = !!(box && inner) && state.phase === 'form' && d.classList.contains('active');
    var bar = d.querySelector('.cart__ctas');
    var vh = window.innerHeight;
    var barTop = bar ? bar.getBoundingClientRect().top : vh;
    if (want) {
      var r = box.getBoundingClientRect();
      var limit = Math.min(vh, barTop > 0 ? barTop : vh);
      var vis = Math.min(r.bottom, limit) - Math.max(r.top, 0);
      if (vis >= Math.min(r.height, 120) * 0.6) want = false; /* the box (title + field) is already on screen */
    }
    if (!pill) {
      if (!want) return;
      pill = document.createElement('button');
      pill.type = 'button';
      pill.className = 'gg-cc-hint';
      pill.setAttribute('aria-label', 'Show the $10 off email signup');
      pill.innerHTML = 'Get $10 off <span aria-hidden="true">↓</span>';
      d.appendChild(pill);
    }
    if (want) {
      var ir = inner.getBoundingClientRect();
      pill.style.left = Math.round(ir.left + ir.width / 2) + 'px';
      pill.style.bottom = Math.round(barTop < vh - 20 ? vh - barTop + 10 : 18) + 'px';
    }
    pill.classList.toggle('is-on', want);
  }
  var hintQueued = false;
  function hintSoon() { if (hintQueued) return; hintQueued = true; requestAnimationFrame(function () { hintQueued = false; hint(); }); }
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('#CartDrawer')) hintSoon();
  }, { capture: true, passive: true });
  window.addEventListener('resize', hintSoon, { passive: true });

  function track(name) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, {}); } catch (e) {}
  }

  function valid(email) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email); }

  function subscribe(email) {
    var body = { data: { type: 'subscription', attributes: {
      custom_source: CFG.source,
      profile: { data: { type: 'profile', attributes: { email: email, properties: { gg_signup_source: 'cart_capture' } } } }
    }, relationships: { list: { data: { type: 'list', id: CFG.list } } } } };
    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + CFG.company, {
      method: 'POST', headers: { 'content-type': 'application/json', revision: CFG.revision }, body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok && r.status !== 202) throw new Error('subscribe ' + r.status); });
  }

  function identify(email) {
    var k = window.klaviyo;
    try {
      if (k && typeof k.identify === 'function') return Promise.resolve(k.identify({ email: email })).catch(function () {});
      (window._learnq = window._learnq || []).push(['identify', { $email: email }]);
    } catch (e) {}
    return Promise.resolve();
  }

  /* Klaviyo does not back-fill an Added to Cart made before identification, and it drops a re-sent Shopify-service
     event (both tested 2026-10-21). So the capture records its own "Added to Cart" event (API metric, property
     gg_source = cart_capture) with the fields the cart-flow templates read (Product Name, Variant Name, ImageURL, Price,
     Quantity). A companion cart flow on that trigger is a founder item; every LATER add, checkout and order of this
     shopper is already tied to the email by identify(), so flows Xe9xL9 and SJxLd9 reach them from the next event. */
  function trackCapture(email) {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var it = cart && cart.items && cart.items[0];
      var k = window.klaviyo;
      if (!it || !k || typeof k.track !== 'function') return;
      var img = it.image || (it.featured_image && it.featured_image.url) || '';
      return k.track('Added to Cart', {
        gg_source: 'cart_capture',
        'Product Name': it.product_title, 'Variant Name': it.variant_title || '', ProductID: String(it.product_id),
        VariantID: String(it.variant_id), Price: it.final_price / 100, Quantity: it.quantity, ImageURL: img,
        URL: location.origin + (it.url || '/cart'), $value: (cart.total_price || 0) / 100, ItemCount: cart.item_count
      });
    }).catch(function () {});
  }

  function submit(form) {
    var input = form.querySelector('#gg-cc-email');
    var email = (input && input.value || '').trim();
    state.email = email;
    if (!valid(email)) { state.error = 'Please enter a valid email address.'; paint(); if (input) input.focus(); return; }
    state.error = ''; state.phase = 'sending'; paint();
    identify(email).then(function () { return subscribe(email); }).then(function () {
      state.phase = 'done'; ssSet('done'); lsSet(); paint(); track('gg_cart_capture_submit');
      setTimeout(function () { trackCapture(email); }, 1200);
    }).catch(function () {
      state.phase = 'form'; state.error = 'Something went wrong. Please try again.'; paint();
    });
  }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.classList && f.classList.contains('gg-cc__form')) { e.preventDefault(); e.stopPropagation(); submit(f); }
  }, true);
  document.addEventListener('input', function (e) { if (e.target && e.target.id === 'gg-cc-email') state.email = e.target.value; }, true);
  document.addEventListener('click', function (e) {
    var pill = e.target && e.target.closest && e.target.closest('.gg-cc-hint');
    if (pill) {
      e.preventDefault();
      var bx = document.querySelector('#CartDrawer .drawer__footer > .gg-cc');
      pill.classList.remove('is-on');
      if (bx) { bx.scrollIntoView({ behavior: 'smooth', block: 'center' }); track('gg_cart_capture_hint'); }
      return;
    }
    if (e.target && e.target.closest && e.target.closest('.gg-cc__close')) {
      e.preventDefault(); state.phase = 'hidden'; ssSet('dismissed'); paint(); track('gg_cart_capture_dismiss');
    }
  });
  /* Keep keystrokes in the field from reaching drawer-level shortcuts (Dawn closes the drawer on Escape only). */
  document.addEventListener('keydown', function (e) { if (e.target && e.target.id === 'gg-cc-email' && e.key !== 'Escape') e.stopPropagation(); }, true);

  /* Drawer open: re-check eligibility (e.g. the shopper joined through the popup meanwhile) and repaint. Closing the
     drawer changes nothing: the box stays until a submit or ×. */
  function watchDrawer() {
    var d = document.querySelector('cart-drawer');
    if (!d) return;
    new MutationObserver(function () {
      if (!d.classList.contains('active')) { hint(); return; }
      setTimeout(hint, 450); /* after the slide-in */
      if (state.phase === 'form' && cookieIdentified() && !preview()) state.eligible = false;
      checkEligible().then(paint);
    }).observe(d, { attributes: true, attributeFilter: ['class'] });
  }

  var queued = false;
  function schedule() { if (queued || painting) return; queued = true; setTimeout(function () { queued = false; paint(); }, 40); }

  function init() {
    if (!slots().length) return;
    checkEligible().then(function () {
      if (!state.eligible) return;
      paint();
    });
    watchDrawer();
    ['cart-drawer', '#main-cart-footer', 'cart-items'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el) new MutationObserver(schedule).observe(el, { childList: true, subtree: true });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
